import { Stack } from '@mantine/core'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { useAllFundInfo } from '@repo/common/queries/funds'

import { FakeSection } from '@/components/FakeSection'
import { HeadlineAndDetails } from '@/components/HeadlineAndDetails'
import { LinkButton } from '@/components/LinkButton'

import { ensure_fund_symbol } from './investments.$symbol.index'

export const Route = createFileRoute('/_app/investments/$symbol/docs/offering')(
  {
    component: OfferingPage,
    onError: () => redirect({ throw: true, to: '/investments' }),
    params: {
      parse: ensure_fund_symbol,
    },
  },
)

function OfferingPage() {
  const { symbol } = Route.useParams()

  const { data: fund } = useAllFundInfo({ symbol })

  if (fund == null) return null

  return (
    <Stack>
      <HeadlineAndDetails
        title={`Offering Document page for ${fund.name} (${fund.symbol})`}
        description=""
      />
      <FakeSection image="document" width="600px" />
      <LinkButton to="/investments/$symbol" params={{ symbol }}>
        Back to Fund
      </LinkButton>
    </Stack>
  )
}
